import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedTimeSlot: "",
  selectedTimeSlotID: 0,
  isSlotSelected: false,
};

const timeSlotWidgetSlice = createSlice({
  name: "timeSlotWidget",
  initialState,
  reducers: {
    updateTimeSlot: (state, action) => {
      state.selectedTimeSlot = action.payload.timeSlot;
      state.selectedTimeSlotID = Number(action.payload.timeSlotId);
      // console.log(`preferred time slot ${state.selectedTimeSlot}`);
      // console.log(`preferred time slot id ${state.selectedTimeSlotID}`);
    },
    updateSlotSelectionStatus: (state, action) => {
      state.isSlotSelected = action.payload;
    },
  },
});

export const { updateTimeSlot, updateSlotSelectionStatus } =
  timeSlotWidgetSlice.actions;

export default timeSlotWidgetSlice.reducer;
